<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-alert v-if="errorOccurred" color="danger" title="Domain Not Found">
      <span>Domain record with id:  not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'admin-list-flashcard-domain'}"
                                        class="text-inherit underline">All Domains</router-link>
      </span>
    </vs-alert>

    <div v-if="domainData" id="domain-data">

      <!--- TOP DOMAIN BANNER START --->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <div class="rounded-lg w-full"
               style="background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
         box-shadow: 0px 4px 25px 0px rgba(0,0,0,.1);">
            <div class="knowledge-base-jumbotron-content rounded-lg lg:p-8 sm:p-8 p-6" style="backdrop-filter: blur(10px)">
              <div class="flex gap-6 items-center ">
                <img :src="domainData.thumbnail" v-if="domainData.thumbnail"  class="rounded-lg" width="200px">
                <div>
                  <h5 class="font-light text-white ml-2 ">FlashCards Admin</h5>
                  <h1 class="text-white font-bold" style="font-size: 4rem">{{ domainData.name }}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--- TOP DOMAIN BANNER END --->

      <!--- DOMAIN ACTION BAR START --->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col grid grid-cols-3 gap-8 w-full">

          <vx-card class=" p-6 cursor-pointer" @click="$router.push(`/a/flashcards/`)"
                   :style="`background-image: linear-gradient(118deg, rgba(var(--vs-primary), 0.4), rgba(var(--vs-primary), .2)), url(${cardBgImgURL})`">
            <div class="flex items-center justify-center">
              <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Back To<br>FlashCard Manager</h2>
            </div>
          </vx-card>
          <vx-card class=" p-6 cursor-pointer" @click="$router.push(`/a/flashcards/domains/${domainData.id}/edit`)"
                   :style="`background-image: linear-gradient(118deg, rgba(var(--vs-success), 0.4), rgba(var(--vs-success), .2)), url(${cardBgImgURL})`">
            <div class="flex items-center justify-center">
              <feather-icon icon="EditIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Edit<br>Domain</h2>
            </div>
          </vx-card>
          <vx-card class="p-6 cursor-pointer text-white" @click="confirmDeleteDomain"
                   :style="`background-image: linear-gradient(118deg, rgba(var(--vs-danger), 0.4), rgba(var(--vs-danger), .2)), url(${cardBgImgURL})`">
            <div class="flex items-center justify-center">
              <feather-icon icon="TrashIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Archive<br>Domain</h2>
            </div>
          </vx-card>
        </div>
      </div>
      <!--- DOMAIN ACTION BAR END --->

      <!--- DOMAIN SHOW INFORMATION START--->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Domain Id</h3>
            <h3 class="font-light">{{ domainData.id }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Domain Status</h3>
            <h3 class="capitalize font-light">{{ domainData.status }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Domain Sets</h3>
            <h3 class="capitalize font-light">{{ domainData.sets.length }}</h3>
          </vx-card>
        </div>
      </div>
      <!--- DOMAIN SHOW INFORMATION END--->

      <!--- DOMAIN SHOW BUILDER START --->
      <build-domain :domain-id="domainData.id"/>


    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>

  </div>
</template>

<script>
import Prism from 'vue-prism-component'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import BuildDomain from '../domain-edit/BuildDomain'

export default {
  data () {
    return {
      cardBgImgURL: 'https://media.discordapp.net/attachments/733851758211629347/954057924630700132/BG2.png?width=1352&height=676',

      domainData: null,
      domainDescriptionCounter: false,
      errorOccurred: false
    }
  },
  components: {
    Prism,
    vSelect,
    Datepicker,
    BuildDomain
  },
  methods: {
    fetchDomainDetails (id) {

      this.$http.get(`flashcards/domains/${id}`)
        .then(response => {

          if (response.status === 200) {
            this.domainData = response.data.data
          }

        })
        .catch(error => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    confirmDeleteDomain () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Archive',
        text: 'Please confirm you want to archive this domain.',
        accept: this.deleteDomain,
        acceptText: 'Archive'
      })
    },
    deleteDomain () {
      this.$vs.loading()

      this.$http.delete(`domains/${this.$route.params.domainId}`)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            this.$router.push('/a/flashcards/domains')

            return this.$vs.notify({
              color: 'success',
              title: 'Domain Archived',
              text: 'You have successfully archived this domain',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }
        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while deleting this domain.'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Delete Group',
            text: error,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    },
    refreshDomainCache (id) {
      this.$vs.loading()

      this.$http.get(`flashcards/domains/${id}/cache`)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            return this.$vs.notify({
              color: 'success',
              title: 'Cache Cleared',
              text: 'The domain cache has been cleared successfully',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }

        })
        .catch(() => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Clear Cache',
            text: 'The domain cache was not cleared successfully',
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    }
  },
  created () {
    this.fetchDomainDetails(this.$route.params.domainId)
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {

  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }

  @media (min-width: 1200px) and (max-width: 1700px) {
    .image-domain {
      display: none;
    }
    .domain-col {
      width: 0 !important;
      min-height: 2.05vh;
    }
    .welcome-col {
      width: 100% !important;
    }
  }
}

</style>
